import { render, staticRenderFns } from "./TestedVersionInformation.vue?vue&type=template&id=4bc5ee56&scoped=true&"
import script from "./TestedVersionInformation.vue?vue&type=script&lang=js&"
export * from "./TestedVersionInformation.vue?vue&type=script&lang=js&"
import style0 from "./TestedVersionInformation.vue?vue&type=style&index=0&id=4bc5ee56&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bc5ee56",
  null
  
)

export default component.exports